// Currencies selectable for the customs value of a parcel, EUR first as default
const customsCurrencies = ['EUR', 'USD', 'GBP', 'CHF', 'NOK', 'SEK', 'DKK', 'PLN', 'CAD', 'AUD', 'JPY', 'CNY'] as const

export type CustomsCurrency = typeof customsCurrencies[number]

// Other currencies have no symbol (a symbol like $ or ¥ is shared by several of them), the currency is shown separately
const currencySymbols: {[currency: string]: string} = {
    EUR: '€',
    USD: '$',
    GBP: '£'
}

// Parcels without a currency (created before #3673) are EUR
export function getCustomsCurrency(customs?: {currency?: string}): string {
    return customs?.currency || 'EUR'
}

export function isCustomsCurrency(currency: string): currency is CustomsCurrency {
    return (customsCurrencies as readonly string[]).includes(currency)
}

// Normalizes a currency delivered by an integration, unknown codes are kept so the user can see and change them
export function normalizeCustomsCurrency(currency?: unknown): string {
    return typeof currency === 'string' && currency.trim() ? currency.trim().toUpperCase() : 'EUR'
}

// Returns an empty string for currencies without a symbol, their code doesn't fit in the value field
export function getCurrencySymbol(currency?: string): string {
    return currencySymbols[currency || 'EUR'] || ''
}

export default customsCurrencies
